package org.hs_soft.runmynesto.domain.model.home.template.product_categories

import kotlinx.serialization.Serializable

@Serializable
data class ListCategories(
    val items: List<TemplateCategoryModel>
)